import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyAyI8MQkpCRdviPu0Y3kTWOcHpnLI3CgAo",
    authDomain: "virtuli-c22b8.firebaseapp.com",
    databaseURL: "https://virtuli-c22b8.firebaseio.com",
    projectId: "virtuli-c22b8",
    storageBucket: "virtuli-c22b8.appspot.com",
    messagingSenderId: "900269643945"
};

export const firebaseApp = firebase.initializeApp(config);

